<template>
  <div class="card">
    <div class="p-3 card-header">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="mb-0">최근 학습 활동</h6>
        <button
          type="button"
          class="btn btn-sm btn-outline-primary"
          @click="refreshActivities"
        >
          <i class="fas fa-sync me-1"></i>
          새로고침
        </button>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                유형
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                활동 내용
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                담당자
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                시간
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(activity, index) in activities" :key="index">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <div
                      class="icon icon-shape icon-sm me-3"
                      :class="getTypeIconClass(activity.type)"
                    >
                      <i class="material-icons-round text-sm">{{ getTypeIcon(activity.type) }}</i>
                    </div>
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ getTypeLabel(activity.type) }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ activity.title }}</p>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="badge badge-sm bg-gradient-secondary">{{ activity.user }}</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ activity.timestamp }}</span>
              </td>
              <td class="align-middle">
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="상세보기"
                >
                  <i class="material-icons-round">arrow_forward</i>
                </a>
              </td>
            </tr>
            <tr v-if="activities.length === 0">
              <td colspan="5" class="text-center py-4 text-sm text-muted">
                최근 활동 내역이 없습니다.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card-footer d-flex justify-content-end py-3">
      <a href="#/academic/activities" class="btn btn-sm btn-outline-primary mb-0">
        전체 활동 보기
        <i class="material-icons-round text-sm ms-1">chevron_right</i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecentActivityTable",
  props: {
    activities: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    getTypeIcon(type) {
      const icons = {
        class: 'school',
        exam: 'assessment',
        question: 'quiz',
        student: 'person',
        grade: 'grade',
        default: 'info',
      };
      return icons[type] || icons.default;
    },

    getTypeIconClass(type) {
      const classes = {
        class: 'bg-gradient-primary',
        exam: 'bg-gradient-success',
        question: 'bg-gradient-warning',
        student: 'bg-gradient-info',
        grade: 'bg-gradient-secondary',
        default: 'bg-gradient-dark',
      };
      return classes[type] || classes.default;
    },

    getTypeLabel(type) {
      const labels = {
        class: '클래스',
        exam: '시험',
        question: '문제',
        student: '학생',
        grade: '성적',
        default: '기타',
      };
      return labels[type] || labels.default;
    },

    refreshActivities() {
      this.$emit('refresh');
    },
  },
};
</script>

<style scoped>
.table thead th {
  padding: 0.75rem 1.5rem;
}

.table tbody td {
  padding: 1rem 1.5rem;
  border-top: 1px solid #f0f2f5;
}

.icon-shape {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
}

.card-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #f0f2f5;
}
</style>
